import {includes} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {track} from 'src/utils/analytics';

const SCHOLARSHIP_TYPE_MAP = {
  CampusVisitScholarship: 'campus-visit',
  SummerProgramScholarship: 'summer-program',
  CollegeReceptionScholarship: 'college-reception',
  CollegeFairScholarship: 'college-fair',
};

const TEST_TYPE_MAP = {
  SatActScholarship: 'sat2016,act',
  PsatPreActScholarship: 'psat2015,preAct',
  ApScoreScholarship: 'ap',
};

const LABEL_MAP = {
  academic: 'a course',
  visits: 'a college event',
  scores: 'a test score',
  volunteer: 'a community service',
  activity: 'an activity',
  sport: 'an activity',
  honor: 'an honor or award',
  referral: 'a referral',
  work: 'work experience',
  multimedia: 'a multimedia item',
  fafsa: 'a FAFSA submission',
  degreeProgress: 'your Associate degree plans',
  collegeSuccess: 'a college success item',
};

const TRACK_MAP = {
  academic: 'course',
  visits: 'college-event',
  scores: 'test-score',
  volunteer: 'community-service',
  activity: 'activity',
  sport: 'sport',
  honor: 'honors-and-awards',
  referral: 'referral',
  work: 'work-experience',
  multimedia: 'multimedia',
  fafsa: 'fafsa',
  degreeProgress: 'degree-progress',
  collegeSuccess: 'college-success',
};

class ScholarshipCTALink extends React.Component {
  static propTypes = {
    scholarship: PropTypes.shape({
      // mapped broad category like 'academic'
      type: PropTypes.string.isRequired,
      // specific scholarship class like 'CourseGradeScholarship'
      scholarshipType: PropTypes.string.isRequired,
      timeSensitiveItemTypeId: PropTypes.string,
      typeDisplay: PropTypes.string,
    }).isRequired,
    // Tab that the button is on. Used for event tracking.
    source: PropTypes.string.isRequired,
    // Modal type is pending evaluation
    pending: PropTypes.bool,
    userInfo: PropTypes.object,
    showScholarshipCta: PropTypes.bool,
    collegeName: PropTypes.string,
    collegeId: PropTypes.string,
    location: PropTypes.object,
  };

  deepLinkMap = () => {
    const {
      scholarship: {scholarshipType, timeSensitiveItemTypeId, typeDisplay},
      collegeName,
      collegeId,
      location: {pathname},
    } = this.props;
    const type = SCHOLARSHIP_TYPE_MAP[scholarshipType];
    const tests = TEST_TYPE_MAP[scholarshipType];

    return {
      academic: {pathname: `${pathname}/course/new`, state: {skipScrolling: true}},
      visits: {
        pathname: `${pathname}/college-success/college-event/${type || 'other-college-event'}/form`,
        search: `?collegeName=${encodeURI(
          collegeName
        )}&collegeId=${collegeId}&event=${typeDisplay}&onlyAwardableEvents=true`,
        state: {skipScrolling: true},
      },
      scores: {
        pathname: `${pathname}/test-score/new`,
        state: {skipScrolling: true},
        ...(tests && {search: `tests=${tests}`}),
      },
      volunteer: {pathname: `${pathname}/community-service/new`, state: {skipScrolling: true}},
      activity: {pathname: `${pathname}/activity/new`, state: {skipScrolling: true}},
      sport: {pathname: `${pathname}/activity/new`, state: {skipScrolling: true, sport: true}},
      honor: {pathname: `${pathname}/honor-award/new`, state: {skipScrolling: true}},
      referral: {pathname: `${pathname}/refer`, state: {skipScrolling: true}},
      work: {pathname: `${pathname}/work-experience/new`, state: {skipScrolling: true}},
      multimedia: {pathname: `${pathname}/multimedia/new`, state: {skipScrolling: true}},
      fafsa: {pathname: `${pathname}/college-success/fafsa/form`, state: {skipScrolling: true}},
      degreeProgress: '/transfers/settings',
      collegeSuccess: {
        pathname: `${pathname}/college-success/time-sensitive/${timeSensitiveItemTypeId}/form`,
        state: {skipScrolling: true},
      },
    };
  };

  render() {
    if (!this.props.showScholarshipCta) return null;

    const {
      userInfo,
      scholarship: {type, scholarshipType},
      source,
      pending,
    } = this.props;

    if (scholarshipType === 'ClaimedAccountScholarship') {
      return null;
    }
    let link = this.deepLinkMap()[type];

    const label = LABEL_MAP[type];
    const category = TRACK_MAP[type];

    if (type === 'fafsa' && (pending || !(userInfo.highSchoolInfo || {}).senior)) {
      return null;
    }

    if (link) {
      let linkText = 'Add in Portfolio';
      let ariaLabelText = `Go to your portfolio and add ${label}`;

      if (type === 'degreeProgress') {
        linkText = 'Edit in Account Settings';
      } else {
        linkText = 'Add';
      }

      if (type === 'fafsa') {
        ariaLabelText = 'Opens the FAFSA modal';
      }

      if (includes(['PerfectAttendanceScholarship', 'OverallGpaScholarship'], scholarshipType)) {
        link = '/portfolio#courses';
        linkText = 'Add in Portfolio';
      }

      return (
        <Link
          className="college-profile-scholarship-cta-link"
          to={link}
          aria-label={ariaLabelText}
          onClick={() => {
            track(`college-listing ${source}-add-${category}`);
          }}
        >
          {linkText}
        </Link>
      );
    }

    return null;
  }
}

export default withRouter(ScholarshipCTALink);
